import React from 'react';
import { useSelector } from 'react-redux';

import { Form, Select, DatePicker } from 'ui/components';
import { SkeletonsForm } from 'ui/components/skeleton';

import { formatDate } from 'utilities/common';
import _ from 'underscore'

const TermOfPayment = [
  { value: 7, label: '7 Hari' },
  { value: 14, label: '14 Hari' },
  { value: 21, label: '21 Hari' },
  { value: 30, label: '30 Hari' },
  { value: 45, label: '45 Hari' },
];

const typeOptions = [
  { value: 'invoices', label: 'Invoices' },
  { value: 'purchase_order', label: 'Purchase Order' },
  { value: 'payment_request', label: 'Payment Request' },
];

const initialState = {
  type: null,
  vendor: null,
  ref_code: '',
  term_of_payment: null,
  periode_project_at: {
    default: new Date(),
    formatted: formatDate(new Date(), 'YYYY-MM'),
  },
  schedule_at: {
    default: new Date(),
    formatted: formatDate(new Date(), 'YYYY-MM-DD'),
  },
  due_at: null,
  is_term_of_payment: false,
  projects: null,
  purchaseOrder: null
};

export const FormGeneral = ({
  data,
  onChange,
  isLoading
}) => {
  const StateForm = useSelector((state) => state?.Form);
  const [
    {
      type,
      vendor,
      ref_code,
      term_of_payment,
      periode_project_at,
      schedule_at,
      due_at,
      is_term_of_payment,
      projects,
      purchaseOrder
    },
    setState,
  ] = React.useState(initialState);

  const dummy = Array.from({ length: 4 }, (v, i) => i);

  const $handleType = async(e) => {
    setState((prevState) => ({
      ...prevState,
      type: e,
    }));
  }

  const $handleVendor = async (e) => {
    setState((prevState) => ({
      ...prevState,
      vendor: e,
    }));
  };

  const $handlePurchaseOrder = async (e) => {
    setState((prevState) => ({
      ...prevState,
      purchaseOrder: e,
    }));
  };

  const $handleProject = async(e) => {
    setState((prevState) => ({
      ...prevState,
      projects: e,
    }));
  }

  const $handlePeriodeProject = async(e) => {
    setState((prevState) => ({
      ...prevState,
      periode_project_at: { default: e, formatted: formatDate(e, 'YYYY-MM') },
    }));
  }

  const $handleSchedule = async (e) => {
    setState((prevState) => ({
      ...prevState,
      schedule_at: { default: e, formatted: formatDate(e, 'YYYY-MM-DD') },
      term_of_payment: null,
    }));
  };

  const $handleTermOfPayment = async (e) => {
    setState((prevState) => ({
      ...prevState,
      term_of_payment: e,
    }));
  };

  React.useEffect(() => {
    if (term_of_payment !== null) {
      const due = new Date(schedule_at?.formatted);
      due.setDate(due.getDate() + term_of_payment?.value);
      setState((prevState) => ({
        ...prevState,
        due_at: { default: due, formatted: formatDate(due, 'YYYY-MM-DD') },
      }));
    } else {
      setState((prevState) => ({
        ...prevState,
        due_at: null,
      }));
    }
  }, [term_of_payment])

  React.useEffect(() => {
    let xp = []

    _.each(projects, function(x) {
      xp.push({id: x?.value})
    })

    const state = {
      type: type?.value,
      vendor,
      purchaseOrder,
      projects: xp,
      ref_code,
      term_of_payment,
      periode_project_at,
      schedule_at,
      due_at,
      is_term_of_payment,
    };

    onChange(state);
  }, [
    type,
    vendor,
    projects,
    purchaseOrder,
    ref_code,
    term_of_payment,
    periode_project_at,
    schedule_at,
    due_at,
    is_term_of_payment,
  ]);

  React.useEffect(() => {
    if (!data) return;

    const t =
      data?.type === 'vendor'
        ? typeOptions[0]
        : data?.type === 'ops'
        ? typeOptions[1]
        : data?.type === 'general_admin'
        ? typeOptions[2]
        : null;

    let top = null
    _.each(TermOfPayment, function(x) {
      if (data?.term_of_payment === x?.value) {
        top = x
      }
    })

    let xp = []
    _.each(data?.projects, function(x) {
      xp.push({label: x?.name, value: x?.id, original: x})
    })

    let dueAt = null
    if (data?.due_at !== '0001-01-01T00:00:00Z') {
      dueAt = {
        default: new Date(data?.due_at),
        formatted: formatDate(data?.due_at, 'YYYY-MM-DD'),
      }
    }

    setState((prevState) => ({
      ...prevState,
      type: t,
      vendor: data?.vendor,
      purchaseOrder: data?.purchase_order,
      ref_code: data?.ref_code,
      term_of_payment: data?.term_of_payment > 0 ? top : null,
      periode_project_at: {
        default: new Date(data?.periode_project),
        formatted: formatDate(data?.periode_project, 'YYYY-MM'),
      },
      schedule_at: {
        default: new Date(data?.schedule_at),
        formatted: formatDate(data?.schedule_at, 'YYYY-MM-DD'),
      },
      due_at: dueAt,
      is_term_of_payment: data?.term_of_payment > 0 ? true : false,
      projects: xp
    }));
  }, [data]);

  return (
    <div className='mt-3 border-bottom'>
      {isLoading ? (
        <div className="row border-bottom">
          {dummy?.map((d, i) => (
            <div className="col-md-6" key={i}>
              <SkeletonsForm count={1} />
            </div>
          ))}
        </div>
      ) : (
        <div className='row'>
          <div className='col-6'>
            <Form.Input
              label="No. Referensi"
              type="text"
              value={ref_code}
              onChange={(e) =>
                setState((prevState) => ({
                  ...prevState,
                  ref_code: e.target.value,
                }))
              }
              error={StateForm?.errors?.ref_code}
            />

            <div className='mb-3'>
              <div className="page-pretitle required">Pilih Tipe</div>
              <Select
                isClearable
                classNamePrefix={
                  StateForm?.errors?.type
                    ? 'is-invalid'
                    : 'select'
                  }
                placeholder=""
                value={type}
                options={typeOptions}
                onChange={(e) => $handleType(e)}
                error={StateForm?.errors?.type}
              />

              {StateForm?.errors?.type ? (
                <div
                  className="invalid-feedback"
                  style={{ display: 'block' }}
                >
                  {StateForm?.errors?.type}
                </div>
              ) : null}
            </div>
            {type?.value === 'invoices' && (
              <div className="mb-3">
                <Select.Remote
                  required
                  label="Pilih Vendor"
                  placeholder=""
                  url="/partner"
                  params={{'type': 'vendor', 'search': vendor ? vendor?.name: ''}}
                  initialValue={vendor?.id}
                  keys={vendor?.id}
                  row={(d) => {
                    return { value: d.id, label: d.name };
                  }}
                  onSelected={(c) => {
                    $handleVendor(c);
                  }}
                  errors={StateForm?.errors?.vendor_id}
                />
              </div>
            )}
            {type?.value === 'purchase_order' && (
              <div className="mb-3">
                <Select.Remote
                  required
                  label="Pilih Purchase Order"
                  placeholder=""
                  url="/vm/po"
                  params={{'document_status': 'payable', 'search': purchaseOrder ? purchaseOrder?.code: ''}}
                  initialValue={purchaseOrder?.id}
                  keys={purchaseOrder?.id}
                  row={(d) => {
                    return { value: d.id, label: d.name };
                  }}
                  onSelected={(c) => {
                    $handlePurchaseOrder(c);
                  }}
                  errors={StateForm?.errors?.purchase_id}
                />
              </div>
            )}
            <div className="mb-3">
              <Select.Remote
                required
                label="Pilih Project"
                placeholder=""
                url="/project"
                initialValue={projects}
                keys={projects}
                params={{"status": "active"}}
                row={(d) => {
                  return { value: d.id, label: d?.customer?.name + ' - ' +  d.name };
                }}
                onSelected={(c) => {
                  $handleProject(c);
                }}
                isMulti
                classNamePrefix={StateForm?.errors?.projects ? 'is-invalid_multi' : 'select_multi'}
                errors={StateForm?.errors?.projects}
              />
              </div>
          </div>
          <div className='col-6'>
            <div className="mb-3">
              <label className="form-label required">Periode Project</label>
              <div
                className={
                  StateForm?.errors?.periode_project_at
                    ? 'border border-danger rounded'
                    : ''
                }
              >
                <DatePicker
                  selectionMode="month"
                  value={periode_project_at?.default || null}
                  format="yyyy/MM"
                  onChange={(date) => {
                    $handlePeriodeProject(date);
                  }}
                  isShowTrigger
                  error={StateForm?.errors?.periode_project_at}
                />
              </div>

              {StateForm?.errors?.periode_project_at ? (
                <div className="invalid-feedback" style={{ display: 'block' }}>
                  {StateForm?.errors?.periode_project_at}
                </div>
              ) : null}
            </div>

            <div className="mb-3">
              <label className="form-label required">Tanggal Pengajuan</label>
              <div
                className={
                  StateForm?.errors?.schedule_at
                  ? 'border border-danger rounded'
                  : ''
                }
              >
                <DatePicker
                  type="normal"
                  value={schedule_at?.default || null}
                  format="dd/MM/yyyy"
                  onChange={(date) => {
                    $handleSchedule(date);
                  }}
                  isShowTrigger
                  error={StateForm?.errors?.schedule_at}
                />
              </div>

              {StateForm?.errors?.schedule_at ? (
                <div className="invalid-feedback" style={{ display: 'block' }}>
                  {StateForm?.errors?.schedule_at}
                </div>
              ) : null}
            </div>
            {(type?.value === 'invoices' || type?.value === 'purchase_order') && (
              <>
                <div className="mb-3">
                  <Form.Checkbox
                    disabled={!schedule_at?.default}
                    onChange={() => {
                      if (!is_term_of_payment) {
                        setState((prevState) => ({
                          ...prevState,
                          is_term_of_payment: true,
                          term_of_payment: null,
                        }));
                      } else {
                        setState((prevState) => ({
                          ...prevState,
                          is_term_of_payment: false,
                          term_of_payment: null,
                        }));
                      }
                    }}
                    iconSize={18}
                    value={is_term_of_payment}
                    label="Pilih Ketentuan Ditagihkan"
                    required={is_term_of_payment}
                  />
                  {is_term_of_payment && (
                    <div className="mt-2">
                      <Select
                        isClearable
                        classNamePrefix={
                          StateForm?.errors?.term_of_payment
                            ? 'is-invalid'
                            : 'select'
                        }
                        placeholder=""
                        value={term_of_payment}
                        options={TermOfPayment}
                        onChange={(e) => $handleTermOfPayment(e)}
                        error={StateForm?.errors?.term_of_payment}
                        isDisabled={!schedule_at?.default}
                      />

                      {StateForm?.errors?.term_of_payment ? (
                        <div
                          className="invalid-feedback"
                          style={{ display: 'block' }}
                        >
                          {StateForm?.errors?.term_of_payment}
                        </div>
                      ) : null}
                    </div>
                  )}
                </div>
              </>
            )}
          </div>
        </div>
      )}
    </div>
  );
};
